//

import { mapGetters, mapActions, mapMutations } from "vuex";
import HighlightJs from "@/directives/highlightjs.directive";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    name: "ScFunctionCodePreview",
    components: { AQCard },
    directives: {
        highlightjs: HighlightJs
    },
    computed: {
        ...mapGetters("smartContractDesigner", [
            "existingFunctionsAsDDL",
            "appBlockchainLanguage",
            "inEditFunction",
            "applicationFunctions",
            "formattedPreviewFunction"
        ]),
        ...mapGetters("apps", ["currentApp"])
    },
    props: {
        idFunction: String,
        allFunction: Object
    },
    data: () => ({
        selectedApplicationPreviewCode: null,
        selectedFunctionForPreview: null
    }),
    watch: {
        selectedFunctionForPreview(val) {
            this.getPreviewCodeForFunction(val);
        }
    },
    methods: {
        ...mapActions("smartContractDesigner", [
            "getSelectedFunctionPreviewCode",
            "setIndexesForProvidedFunction"
        ]),
        ...mapMutations("smartContractDesigner", ["setIndexesForProvidedFunction"]),

        getPreviewCodeForFunction(funcId) {
            this.$store.commit(
                "smartContractDesigner/setAppBlockchainLanguage",
                this.allFunction && this.allFunction.bcType === "BC_HLF"
                    ? "go"
                    : "solidity"
            );

            const funcToModify = { ...this.allFunction };
            let functToSend = null;
            if (funcToModify.body && funcToModify.diagramData) {
                this.setIndexesForProvidedFunction(funcToModify);
                functToSend = this.formattedPreviewFunction;
            } else {
                functToSend = funcToModify;
            }
            this.getSelectedFunctionPreviewCode(functToSend).then(
                data => {
                    this.selectedApplicationPreviewCode = data.data
                        ? data.data.source
                        : "";
                    this.$emit("previewCode", this.selectedApplicationPreviewCode);
                },
                err => {
                    console.log(err);
                }
            );
        }
    },
    mounted() {
        this.selectedFunctionForPreview = this.idFunction;
    }
};
